import {
    GET_EVENT_TRACKING_LOG_SUCCESS,
    GET_SELECTED_USER_SUCCESS
} from '../../actions/types';

const INITIAL_STATE = {
    log: {},
    selectedUser: {}
};

export default (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_EVENT_TRACKING_LOG_SUCCESS:
            return { ...state, log: payload };
        case GET_SELECTED_USER_SUCCESS:
            return {
                ...state,
                selectedUser: payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/eventTracking/EventTrackingReducer.js